module.exports = __webpack_public_path__ + "img/menu-badge-icon-red.71e1b80d.png";